import * as React from "react";

import { Resources, useResource } from "Translations/Resources";
import { booleanListItems } from "Utils/FilterUtils";
import { useDispatch, useSelector } from "react-redux";
import { AccessRightCodes } from "Components/Models/AccessRights";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { BreadcrumbItem } from "Components/Layout/Breadcrumbs";
import { CompaniesTable } from "Components/Companies/CompaniesTable";
import { CompanyDto, FilterPropsCompanies } from "Api/Api";
import { CookieNames } from "Components/Models/CookieNames";
import { Dictionary } from "lodash";
import { RootStateType } from "State/Store";
import { getCompaniesAsync } from "State/Companies/CompanyReducer";
import { useTableFiltration } from "Hooks/Tables/useTableFiltration";
import { booleanValueMapper } from "Utils/FilterUtils";
import { useHasCurrentUserAccessRight } from "Hooks/useHasCurrentUserAccessRight";

export const CompaniesPage: React.FunctionComponent = _ => {
  const { t } = useResource();
  const dispatch = useDispatch();
  const { isLoading, companies } = useSelector(
    (e: RootStateType) => e.companies,
  );

  const hasAccessRight = useHasCurrentUserAccessRight();

  function getRoleListItems() {
    const roleListItems = {
      none: t(Resources.Companies.SelectBox.None),
    } as Dictionary<string>;

    if (hasAccessRight([AccessRightCodes.Core_Company_Customer_Read])) {
      roleListItems["customer"] = "Odběratel";
    }
    if (hasAccessRight([AccessRightCodes.Core_Company_Supplier_Read])) {
      roleListItems["supplier"] = "Dodavatel";
      roleListItems["marketplace"] = "Marketplace";
    }

    return roleListItems;
  }

  const [filtration] = useTableFiltration<CompanyDto, FilterPropsCompanies>({
    tableCode: CookieNames.Companies,
    onDataLoad: filter => {
      dispatch(
        getCompaniesAsync.request({
          ...filter,
          limit: filter.rows,
          offset: filter.page * filter.rows,
        }),
      );
    },
    defaultOrderBy: "name",
    filters: [
      {
        propertyName: "name",
        defaultValue: "",
      },
      {
        propertyName: "street",
        defaultValue: "",
      },
      {
        propertyName: "postalCode",
        defaultValue: "",
      },
      {
        propertyName: "city",
        defaultValue: "",
      },
      {
        propertyName: "role",
        defaultValue: "none",
        listItems: getRoleListItems(),
      },
      {
        propertyName: "isActive",
        defaultValue: "true",
        valueMapper: booleanValueMapper,
        listItems: booleanListItems,
      },
    ],
  });

  return (
    <AuthenticatedLayout
      title={t(Resources.Companies.Title)}
      create={{
        accessRightCodes: [
          AccessRightCodes.Core_Company_Customer_Edit,
          AccessRightCodes.Core_Company_Supplier_Edit,
        ],
        url: `/${t(Resources.Routes.Companies)}/${t(
          Resources.Routes.CompanyCreate,
        )}`,
        title: t(Resources.Companies.List.BtnCreate.Title),
      }}
      breadcrumbItems={[
        {
          name: t(Resources.Companies.List.Breadcrumb.Title),
        } as BreadcrumbItem,
      ]}
    >
      <CompaniesTable
        companies={companies}
        onPageChange={filtration.onPageChange}
        isLoading={isLoading}
        filter={filtration.getFilterProps()}
        orderBy={filtration.ordering}
        paginationParams={filtration.pagination}
      />
    </AuthenticatedLayout>
  );
};
